// extracted by mini-css-extract-plugin
export default {"container":"style_container__odz83","title":"style_title__IAIlq","cross_image":"style_cross_image__Womq8"};